import { filterListByKey } from 'utils/filterList';
import { assetStatus } from 'utils/constants/assetText';
import { convertDateTime, compareDates } from 'utils/time';
import { isEmpty } from 'lodash';

export const getQualifiedAsset = (asset, personnelDetails) => {
  const availableAsset = getAvailableAsset(asset);

  const qualifiedAsset = filterAssetByPersonnelQualification(
    availableAsset,
    personnelDetails,
  );
  return qualifiedAsset;
};

const getAvailableAsset = asset => {
  return filterListByKey(asset, [assetStatus.AVAILABLE], 'status');
};

export const getMatchedQualifications = (personnelDetails, asset) => {
  //we use a combination of (assetName + assetID + assetTypeName) as a name label for an asset
  // so typeName would be included in the asset object label
  const [
    matchedQualification,
  ] = personnelDetails.details.qualifications.filter(data =>
    asset.name.includes(data.typeName),
  );
  return matchedQualification;
};

export const matchedQualificationDate = qualification => {
  const todaysDate = convertDateTime(new Date(), 'YYYY-MM-DD');
  const date1 = compareDates(todaysDate, qualification.validFrom);
  if (!isEmpty(qualification.validTo)) {
    const date2 = compareDates(qualification.validTo, todaysDate);
    return date1 === todaysDate && date2 === qualification.validTo;
  }
  return date1 === todaysDate;
};

const filterAssetByPersonnelQualification = (
  availableAsset,
  personnelDetails,
) => {
  const asset = availableAsset.reduce((selectedValues, currentValue) => {
    if (currentValue.qualificationRequired) {
      if (
        personnelDetails.details.qualifications !== null &&
        personnelDetails.details.qualifications.length > 0
      ) {
        const matchedQualification = getMatchedQualifications(
          personnelDetails,
          currentValue,
        );
        if (
          matchedQualification &&
          matchedQualificationDate(matchedQualification)
        ) {
          selectedValues.push({
            id: currentValue.id,
            label: currentValue.name,
            assetId: currentValue.assetId,
          });
        }
      }
    } else {
      selectedValues.push({
        id: currentValue.id,
        label: currentValue.name,
        assetId: currentValue.assetId,
      });
    }
    return selectedValues;
  }, []);
  return asset;
};

export const getSelectedAssetData = (asset, selectedAssetId) => {
  return asset.find(assetData => assetData.id === selectedAssetId);
};
